import Service from '../Service'

const record = {

    sendActivityData (data) {
        return Service.post(`api/user-activity`, {
            user_activity_type_id: data.user_activity_type_id,
            uuid: data.uuid,
            value: data.value
        });
    }

}

export default record;